<template>
  <patient-profile>
    <template v-slot:head>
      <button
        v-if="!isMobile"
        class="patient-plans__button-create"
        type="button"
        v-on:click="openFormPlanCreation"
      >Новый план</button>
    </template>
    <mobile-fixed-bottom-popup
      v-if="shownWorkOnPCMobilePopup"
      v-on:close="onCloseWorkOnPCMobileAppPopup"
    >
      Совет. Работать в программе удобнее с компьютера.
    </mobile-fixed-bottom-popup>
    <modal-dialog-prevent-leave
      v-bind:is-shown="isShownDialogLeaveConfirm"
      v-on:back="isShownDialogLeaveConfirm = false"
      v-on:leave="leaveWithoutSave"
      v-on:save="saveAndLeave"
    />
    <modal-dialog
      title="Выберите прайс лист"
      max-width="750"
      v-bind:value="shownPriceListsSelectModal"
      v-on:on-click-outside="shownPriceListsSelectModal = false"
    >
      <price-lists-select-modal
        v-bind:price-lists=serviceGroupedByPriceList
        v-on:select-price-list="onSelectedPriceList"
      />
    </modal-dialog>
    <modal-dialog
      title="Выберите шаблон"
      width="100%"
      max-width="350"
      with-cross
      v-model="isShowModalSelectTreatmentPlanCategory"
      v-on:on-click-outside="onCloseTreatmentPlanTemplateSelectTree"
    >
      <select-item-tree-dialog
        v-bind:fetch-children="getTreatmentPlanTemplateCategoryChildren"
        v-bind:items=treatmentsPlanTemplateCategoryTree
        v-on:change="onChangeSelectTreatmentPlanTemplate"
        v-on:created="getTreatmentPlanTemplateCategoriesTree"
      />
    </modal-dialog>
    <picker-services
      title="Выберите услуги"
      with-select-teeth
      v-bind:with-previous-button="true"
      v-bind:price-list-name="selectedPriceListName"
      v-bind:initial-category-list="selectedCategories"
      v-bind:shown-accordion="shownAccordionServices"
      v-model="shownAddingServicesFromPriceModal"
      v-on:add-service="onAddingPriceService"
      v-on:on-previous-button="onPreviousButton"
    >
      <template v-slot:header>
        <input-text-search
          class="patient-visits__services__search-input"
          placeholder="Введите название услуги"
          v-bind:is-loading="isAwaitLoadingMatchedServices"
          v-bind:violations="searchInputViolations"
          v-model="searchQuery"
        />
      </template>
      <template
        v-slot:default="{
          emitAddService,
          selectedServices,
        }">
        <matched-service-list
          v-bind:show-price-name="false"
          v-bind:matched-service-list="matchedServiceList"
          v-bind:selectedServices="selectedServices"
          v-on:select-service="emitAddService"
        />
      </template>
    </picker-services>
    <iframe
      class="patient-plans__print"
      ref="printView"
      title="printView"
    />
    <collapse-button
      caption="Планы"
      class="patient-plans__slider"
      v-if="!isEmptyList">
      <the-carousel>
        <template v-for="plan in planList">
          <button
            class="patient-plans__slide"
            type="button"
            v-bind:class="{ selected: selectedId === plan.id }"
            v-bind:disabled="isAwaitRequest"
            v-bind:key="plan.id"
            v-on:click="openPlan(plan.id)"
          >
            <div class="patient-plans__slide__row">
              <div class="patient-plans__slide__name">{{ plan.name }}</div>
              <button
                v-if="plan.statusId !== 'IN_WORK' && plan.statusId !== 'COMPLETED'"
                class="patient-plans__slide__icon-delete"
                type="button"
                v-on:click.stop="onDeletePlan(plan.id)" />
            </div>
            <time>{{ plan.date }}</time>
            <div class="patient-plans__slide__price">
              Итого: <span>{{ plan.price }}</span>
            </div>
          </button>
        </template>
      </the-carousel>
    </collapse-button>
    <button
      v-if="isEmpty"
      class="patient-plans patient-plans__empty"
      type="button"
      v-on:click="openFormPlanCreation"
    >
      <b>Создать</b> план лечения
    </button>
    <form
      class="patient-plans"
      v-bind:key="isCreate"
      v-else-if="showForm"
      v-on:submit.prevent="onSavePlan"
    >
      <section class="patient-plans__plan">
        <div class="patient-plans__plan__row">
          <div class="patient-plans__plan__group">
            <div class="patient-plans__plan__group-name">
              <p v-if="!isEditPlanName">{{ plan.name }}</p>
              <input
                class="patient-plans__plan__name"
                ref="planName"
                v-else
                v-model="plan.name"
                v-on:blur="isEditPlanName = false"
              />
              <button
                class="patient-plans__plan__icon-edit"
                type="button"
                v-on:click="showInputPlanName"
              />
            </div>
            <date-picker-dialog v-model="plan.date">
              <template v-slot:trigger="{ listenerObject }">
                <button
                  class="patient-plans__plan__datetime"
                  type="button"
                  v-if="plan.date"
                  v-on="listenerObject"
                >
                  {{ dateAtTitle }}
                </button>
                <button
                  v-else
                  class="patient-plans__plan__datetime"
                  type="button"
                  v-on="listenerObject"
                >
                  Укажите дату
                </button>
              </template>
            </date-picker-dialog>
          </div>
        </div>
        <div class="patient-plans__plan__group validity-period">
          <date-picker-dialog
            v-model="plan.effectiveUntil"
            v-on:input="onChangeEffectiveUntilDate"
          >
            <template v-slot:trigger="{ listenerObject }">
              <span class="validity-period__text">Действует до:</span>
              <button
                v-if="plan.effectiveUntil"
                class="patient-plans__plan__datetime-field"
                title="Изменить период"
                type="button"
                v-on="listenerObject"
              >
                <time v-bind:datetime="$options.convertToInputDate(plan.effectiveUntil)">
                  {{ effectiveUntilTitle }}
                </time>
              </button>
              <button
                v-else
                class="patient-plans__plan__datetime-field"
                title="Выбрать период"
                type="button"
                v-on="listenerObject"
              >Укажите дату</button>
            </template>
          </date-picker-dialog>
          <date-range-presets
            class="patient-plans__plan__date-range"
            v-bind:presets="periodPresets"
            v-bind:button-clear-show="!!plan.effectiveUntil"
            v-model="periodDates"
            v-on:input="onChangePeriod"
            v-on:click-clear="clearEffectiveUntilDate"
          />
        </div>
        <p
          class="text__violation"
          role="alert"
          v-for="error in nameInputErrors"
          v-bind:key="error"
        >
          {{ error }}
        </p>
        <div class="patient-plans__plan__group-inputs">
          <the-select
            class="patient-plans__plan__status"
            title="Статус"
            option-title-key="text"
            option-value-key="value"
            v-bind:options="planStatuses"
            v-model="planStatus"
          />
          <div class="patient-plans__plan__employee">
            <span class="patient-plans__plan__employee-title">
              Врач
            </span>
            <autocomplete-input
              class="patient-plans__plan__employee-field"
              item-text="title"
              item-value="value"
              placeholder="Выберите врача"
              outlined
              dense
              clearable
              hide-details
              v-bind:menu-props="{
                contentClass: 'text-big',
                maxWidth: 'min(80%, 450px)',
              }"
              v-bind:items="doctorList"
              v-model="doctor"
            />
          </div>
          <div class="patient-plans__plan__employee">
            <span class="patient-plans__plan__employee-title">
              Ответственный
            </span>
            <autocomplete-input
              class="patient-plans__plan__employee-field"
              item-text="full_name"
              item-value="id"
              placeholder="Выберите ответственного"
              outlined
              dense
              clearable
              hide-details
              v-bind:menu-props="{
                contentClass: 'text-big',
                maxWidth: 'min(80%, 450px)',
              }"
              v-bind:items="employeeList"
              v-model="responsibleEmployee"
            />
          </div>
        </div>
        <available-section section="treatment-plan-templates">
          <div
            v-if="hasTemplates && !isAwaitTemplates && (isDraft || isCreate)"
            class="patient-plans__plan__search print-hide"
          >
            <search-input
              label="Выберите шаблон"
              placeholder="Название шаблона"
              item-text="title"
              item-value="value"
              v-bind:items="optionsOfTemplates"
              v-on:input="onApplyTemplate"
              v-on:open-modal="onShowTreatmentPlanTemplateCategorySelectModal"
              v-bind:has-open-modal="true"
              v-bind:value="plan.templateId"
            />
          </div>
          <div v-else-if="!isAwaitTemplates && !hasTemplates && (isDraft || isCreate) ">
            <router-link
              class="patient-plans__plan__link"
              v-bind:to="{ name: 'ClinicPanelTreatmentPlanTemplateList' }"
            >
              Создайте шаблоны планов лечения
            </router-link>
          </div>
          <div
            v-if="plan.templateName"
            class="treatment-plan-templates__description"
          >
            По шаблону «{{ plan.templateName }}»
          </div>
        </available-section>
      </section>
      <plan-services-table
        v-bind:has-stages="hasStages"
        v-bind:initial-discount-type="plan.discountType"
        v-bind:is-show-plan-progress="isShowPlanProgress"
        v-bind:key="plan.templateId"
        v-bind:rows="plan.serviceList"
        v-bind:stages="plan.stages"
        v-on:move-row="onMoveRow"
        v-on:move-row-last="onMoveRowLast"
        v-on:move-row-between-stages="onMoveRowBetweenStages"
        v-on:move-row-between-stages-last="onMoveRowBetweenStagesLast"
        v-on:add-stage-service="addStageService($event); onClickServiceSelect();"
        v-on:input-discount-type="onInputDiscountType"
        v-on:change-stage="onChangeStage"
        v-on:change="onChangeService"
        v-on:delete-stage="onDeleteStage"
        v-on:delete="onDeleteService"
      />
      <div class="patient-plans__plan__buttons">
        <button
          class="patient-plans__plan__button-add"
          type="button"
          v-on:click="addNewStage">
          добавить этап
        </button>
        <button
          class="patient-plans__plan__button-add"
          type="button"
          v-if="!isAwaitRequest && !hasStages"
          v-on:click="onClickServiceSelect">
          добавить услуги
        </button>
      </div>
      <div class="patient-plans__plan__buttons-second">
        <button
          class="patient-plans__plan__button-save"
          v-bind:disabled="disableSaveButton"
          type="submit"
          v-if="showSavePrintButton"
        >
          Сохранить
        </button>
        <button
          class="patient-plans__plan__button-print"
          v-on:click="onPlanPrint"
          type="button"
          v-if="showSavePrintButton && !isMobile"
        >
          Печать
        </button>
        <button
          class="patient-plans__plan__button-download"
          v-on:click="onPlanDownload"
          type="button"
          v-if="showSavePrintButton && !isMobile"
        >
          Скачать
        </button>
      </div>
    </form>
  </patient-profile>
</template>

<script>
import notifierMixin from '@/mixins/notifierMixin';
import dateMixin from '@/mixins/dateMixin';
import { convertToInputDate } from '@/utils/timeFormat';
import DatePickerDialog from '@/components/DatePickerDialog.vue';
import PlanServicesTable from '@/components/PlanServicesTable.vue';
import {
  CreatePlanRequest,
  EditPlanRequest,
  Plan,
  PlanService,
  PatientPlanStage,
  PlanTemplateStage,
} from '@/storage/gateways/PlanGateway';
import { PositionDiscount } from '@/storage/gateways/VisitGateway';
import { builtInDialogMixin, DialogResult } from '@/components/ClinicPanelDialog.vue';
import SearchInput from '@/components/SearchInput.vue';
import ModalDialogPreventLeave from '@/components/ModalDialogPreventLeave.vue';
import preventLeaveWithoutConfirmMixin from '@/mixins/preventLeaveWithoutConfirmMixin';
import TheCarousel from '@/components/TheCarousel.vue';
import CollapseButton from '@/components/CollapseButton.vue';
import patientPlanMixin from '@/mixins/patientPlanMixin';
import addingServicesFromPriceMixin from '@/mixins/addingServicesFromPriceMixin';
import PickerServices from '@/components/PickerServices.vue';
import MatchedServiceList from '@/components/MatchedServiceList.vue';
import TheSelect from '@/components/TheSelect.vue';
import AutocompleteInput from '@/components/AutocompleteInput.vue';
import InputTextSearch from '@/components/InputTextSearch.vue';
import PatientProfile from '@/views/ClinicPanel/PatientProfile.vue';
import { DISCOUNT_IN_KOPECK } from '@/components/SwitchDiscountType.vue';
import mobileMixin from '@/mixins/mobileMixin';
import mobilePopupMixin from '@/mixins/mobilePopupMixin';
import AvailableSection from '@/views/ClinicPanel/AvailableSection.vue';
import saveFileMixin from '@/mixins/saveFileMixin';
import MobileFixedBottomPopup from '@/components/MobileFixedBottomPopup.vue';
import PriceListsSelectModal from '@/components/PriceListsSelectModal.vue';
import ModalDialog from '@/components/ModalDialog.vue';
import DateRangePresets from '@/components/DateRangePresets.vue';
import SelectItemTreeDialog from '@/components/SelectItemTreeDialog.vue';
/**
 * @description Разрешить получение списка ошибок для поля ввода.
 * @param {string} cause Имя поля ввода.
 * @returns {function}
 */
const resolveInputErrors = (cause) => (vm) => (
  cause in vm.inputErrors ? vm.inputErrors[cause] : []
);

export default {
  components: {
    SelectItemTreeDialog,
    ModalDialog,
    PriceListsSelectModal,
    MobileFixedBottomPopup,
    AvailableSection,
    PatientProfile,
    DatePickerDialog,
    ModalDialogPreventLeave,
    PlanServicesTable,
    TheCarousel,
    CollapseButton,
    SearchInput,
    PickerServices,
    MatchedServiceList,
    TheSelect,
    AutocompleteInput,
    InputTextSearch,
    DateRangePresets,
  },
  statusDraft: 'DRAFT',
  statusToBeAgreed: 'TO_BE_AGREED',
  convertToInputDate,
  computed: {
    /**
     * @description Показывать прогресс выполнения.
     * @returns {void}
     */
    isShowPlanProgress() {
      return this.plan.tags.includes('progress');
    },
    /**
     * @description Заголовок даты визита.
     * @type {string}
     */
    dateAtTitle() {
      const options = {
        day: 'numeric',
        month: 'long',
      };
      const dayAndMonth = this.plan.date.toLocaleDateString('ru-RU', options);
      const weekday = this.plan.date
        .toLocaleDateString('ru-RU', { weekday: 'short' })
        .toUpperCase();
      return `${dayAndMonth}, ${weekday}`;
    },
    /**
     * @description Заголовок даты действия плана.
     * @returns {string}
     */
    effectiveUntilTitle() {
      const options = {
        day: 'numeric',
        month: 'numeric',
        year: 'numeric',
      };
      return this.plan.effectiveUntil.toLocaleDateString('ru-RU', options);
    },
    /**
     * @description Деактивировать кнопку сохранения.
     * @type {boolean}
     */
    disableSaveButton() {
      return !this.needPreventLeave || !this.hasServices || this.isAwaitRequest;
    },
    /**
     * @description Показать кнопки сохранения и печать.
     * @type {boolean}
     */
    showSavePrintButton() {
      return this.selectedId || this.hasServices;
    },
    /**
     * @description Имеются этапы.
     * @return {boolean}
     */
    hasStages() {
      return this.plan.stages.length > 0;
    },
    /**
     * @description Имеются услуги.
     * @return {boolean}
     */
    hasServices() {
      return this.plan.serviceList.length > 0
        || this.plan.stages.filter((stage) => stage.serviceList.length > 0).length > 0;
    },
    /**
     * @description Имеются шаблоны.
     * @type {boolean}
     */
    hasTemplates() {
      return this.templates.length > 0;
    },
    /**
     * @description Список планов пуст.
     * @type {boolean}
     */
    isEmpty() {
      return !this.isCreate && this.planList.length === 0 && !this.isAwaitRequest;
    },
    isEmptyList({ planList }) {
      return planList.length === 0;
    },
    nameInputErrors: resolveInputErrors('name'),
    /**
     * @description Предотвращать уход со страницы.
     * @type {boolean}
     */
    needPreventLeave() {
      return this.isPlanChanged;
    },
    /**
     * @description Варианты шаблонов.
     * @type {{title: string, value: string}[]}
     */
    optionsOfTemplates() {
      return this.templates.map((template) => ({
        title: template.getName(),
        value: template.getId(),
      }));
    },
    /**
     * @description Идентификатор пациента.
     * @type {number}
     */
    patientId() {
      return parseInt(this.$route.params.id, 10);
    },
    /**
     * @description Идентификатор плана.
     * @type {number}
     */
    planId({ isCreatePlan, $route, $options }) {
      if (isCreatePlan) {
        return $options.createPlanRouteName;
      }
      const { planId } = $route.params;
      return parseInt(planId, 10);
    },
    /**
     * @description Статус плана.
     * @returns {any}
     */
    planStatus: {
      /**
       * @description Получить статус.
       * @returns {string}
       */
      get() {
        return this.plan.status;
      },
      /**
       * @description Установить статус.
       * @param {string} value Статус.
       * @returns {void}
       */
      set(value) {
        this.plan.status = value;
      },
    },
    /**
     * @description Ответственный за план сотрудник.
     * @returns {any}
     */
    responsibleEmployee: {
      /**
       * @description Получить ответственного сотрудника.
       * @returns {string}
       */
      get() {
        return this.plan.employeeId;
      },
      /**
       * @description Установить ответственного сотрудника.
       * @param {number} value Идентификатор сотрудника.
       * @returns {void}
       */
      set(value) {
        this.plan.employeeId = value;
      },
    },
    /**
     * @description Врач.
     * @returns {any}
     */
    doctor: {
      /**
       * @description Получить врача.
       * @returns {string}
       */
      get() {
        return this.plan.doctorId;
      },
      /**
       * @description Установить врача.
       * @param {number} value
       * @returns {void}
       */
      set(value) {
        this.plan.doctorId = value;
      },
    },
    /**
     * @description Список услуг.
     * @type {any[]}
     */
    services() {
      return [];
    },
    /**
     * @description Список категорий услуг.
     * @type {any[]}
     */
    serviceCategories() {
      return [];
    },
    /**
     * @description Идентификатор плана.
     * @type {number}
     */
    selectedId() {
      return this.plan ? this.plan.id : null;
    },
    /**
     * @description Показывать форму.
     * @type {boolean}
     */
    showForm() {
      return this.selectedId || this.isCreate;
    },
    /**
     * Изменен ли наш план
     * @return {boolean}
     */
    isPlanChanged() {
      return this.plan.isChanged() || this.templateWasApplied;
    },
    /**
     * @description Является ли план лечения черновиком.
     * @returns {boolean}
     */
    isDraft() {
      return this.planStatus === this.$options.statusDraft;
    },
    /**
     * @description Предварительные установки периодов.
     * @returns {{toValue: function(): [Date,Date], id: string, label: string, title: string}[]}
     */
    periodPresets() {
      return this.periodTypes.map(({ periodDates, title, value }) => ({
        id: value,
        label: title,
        title,
        toValue: () => periodDates,
      }));
    },
  },
  async created() {
    this.fetchTreatmentPlatTemplateCategories();
    this.fetchTreatmentPlanFillers();
    this.fetchPlanStatuses();
    this.reloadPlanList();
    this.fetchResponsibleEmployeeList();
    if (this.isCreate !== true) {
      this.fetchPlan(this.planId);
    }
  },
  data() {
    return {
      /**
       * @description Категории с дочерними шаблонами.
       * @type {Array}
       */
      treatmentsPlanTemplateCategoryTree: [],
      /**
       * @description Категории шаблонов планов лечения.
       * @type {Array<PlanCategory>}
       */
      treatmentsPlanTemplateCategories: [],
      /**
       * @description Показывать модальное окно выбора шаблона в категориях.
       * @type {boolean}
       */
      isShowModalSelectTreatmentPlanCategory: false,
      /**
       * @description Нарушение ограничений.
       * @type {any}
       */
      inputErrors: {},
      /**
       * @description Ожидание окончания запроса.
       * @type {boolean}
       */
      isAwaitRequest: false,
      /**
       * @description Редактирование названия плана.
       * @type {boolean}
       */
      isEditPlanName: false,
      /**
       * @description План.
       * @type {Plan}
       */
      plan: new Plan(),
      /**
       * @description Список планов пациента.
       * @type {PlanItem[]}
       */
      planList: [],
      /**
       * @description Статусы плана лечения.
       * @type {any[]}
       */
      planStatuses: [],
      /**
       * @description Список докторов.
       * @type {any[]}
       */
      doctorList: [],
      /**
       * @description Список сотрудников.
       * @type {any[]}
       */
      employeeList: [],
      /**
       * Был ли применен шаблон
       */
      templateWasApplied: false,
      /**
       * @description Шаблоны.
       * @type {PlanTemplate[]}
       */
      templates: [],
      /**
       * @description Ожидание загрузки шаблонов.
       * @type {boolean}
       */
      isAwaitTemplates: true,
      /**
       * @description Выбранный этап
       */
      selectedStage: null,
      /**
       * @description Типы периодов.
       */
      periodTypes: [],
      /**
       * @description Даты периода.
       */
      periodDates: [],
    };
  },
  methods: {
    /**
     * @description Обработать событие выбора шаблона плана лечения.
     * @param template
     * @returns {void}
     */
    onChangeSelectTreatmentPlanTemplate(template) {
      if (template) {
        this.onApplyTemplate(template.id);
      }
      this.onCloseTreatmentPlanTemplateSelectTree();
    },
    /**
     * @description Обработать событие закрытия дерева выбора шаблона.
     * @returns {void}
     */
    onCloseTreatmentPlanTemplateSelectTree() {
      this.isShowModalSelectTreatmentPlanCategory = false;
    },
    /**
     * @description Затянуть категории шаблонов планов лечения.
     * @returns {void}
     */
    async fetchTreatmentPlatTemplateCategories() {
      this.$planGateway
        .getCategories()
        .then((result) => {
          result.forEach((categories) => {
            this.treatmentsPlanTemplateCategories = categories;
            this.isAwaitTemplates = false;
          });
        })
        .finally(() => {
          this.isAwaitTemplates = false;
        });
    },
    /**
     * @description Получить список категорий шаблонов плана лечения.
     * @returns {void}
     */
    async getTreatmentPlanTemplateCategoriesTree() {
      this.treatmentsPlanTemplateCategoryTree = this
        .treatmentsPlanTemplateCategories
        .map((item) => ({
          id: item.id,
          name: item.name,
          children: [],
        }));
    },
    /**
     * @description Получить шаблоны по категории.
     * @param {Object} item
     * @returns {void}
     */
    async getTreatmentPlanTemplateCategoryChildren(item) {
      const children = this
        .templates
        .filter((template) => template.getCategoryId() === item.id)
        .map((template) => ({
          id: template.getId(),
          name: template.getName(),
        }));
      item.children.push(...children);
    },
    /**
     * @description Обработать событие выбора
     * @returns {void}
     */
    onShowTreatmentPlanTemplateCategorySelectModal() {
      this.isShowModalSelectTreatmentPlanCategory = true;
    },
    /**
     * @description Обработать изменение даты "действует до".
     * @param {Date} value
     */
    onChangeEffectiveUntilDate(value) {
      this.periodDates = [
        this.plan.date,
        value,
      ];
    },
    /**
     * @description Обработать выбор периода.
     * @param {array} value
     * @returns {void}
     */
    onChangePeriod(value) {
      const [, to] = value;
      this.plan.effectiveUntil = to;
    },
    /**
     * @description Очистить дату действия плана.
     * @returns {void}
     */
    clearEffectiveUntilDate() {
      this.plan.effectiveUntil = null;
      this.periodDates = [];
    },
    /**
     * @description добавить новый этап
     *
     * @returns {void}
     */
    addNewStage() {
      if (!this.hasStages) {
        this.plan.stages.push(new PatientPlanStage(null, this.plan.serviceList, 'Этап 1'));
        this.plan.serviceList = [];
      } else {
        const stageNumber = this.plan.stages.length + 1;
        const stageName = `Этап ${stageNumber}`;
        this.plan.stages.push(new PatientPlanStage(null, [], stageName));
      }
    },
    /**
     * @description Обработать добавление услуги из прайса.
     * @param {Object} service Услуга.
     * @returns {void}
     */
    onAddingPriceService(service) {
      const currentService = new PlanService(
        false,
        service.categoryName,
        1,
        service.dentalParts || [],
        new PositionDiscount(this.plan.discountType, 0),
        null,
        `${service.id}-${Date.now()}`,
        service.cost,
        '',
        service.id,
        service.name,
        service.teeth || [],
        service.units,
      );
      if (this.selectedStage !== null) {
        this.plan.stages[this.selectedStage].serviceList.push(currentService);
        return;
      }
      this.plan.serviceList.push(currentService);
    },
    /**
     * @description Перед закрытием плана.
     * @param {function} action Действие.
     * @returns {void}
     */
    beforePlanLeave(action) {
      if (this.needPreventLeave) {
        this.actionAfterClosingDialogLeaveConfirm = action;
        this.isShownDialogLeaveConfirm = true;
      } else {
        action();
      }
    },
    /**
     * @description Открыть форму для создания плана.
     * @returns {void}
     */
    openFormPlanCreation() {
      const navigate = () => {
        if (this.isCreate) {
          this.plan = new Plan();
        } else {
          const to = this.getFormCreationLocation(this.patientId);
          this.$router.replace(to);
        }
      };
      this.beforePlanLeave(navigate);
    },
    /**
     * @description Получить план.
     * @type {number} id Идентификатор плана.
     * @returns {Promise<Validation>}
     */
    async fetchPlan(id) {
      this.isAwaitRequest = true;
      const result = await this.$planGateway.viewById(id);
      result.forEach(({ plan }) => {
        this.plan = plan;
        this.templateWasApplied = false;
        if (plan.effectiveUntil) {
          this.periodDates = [
            plan.date,
            plan.effectiveUntil,
          ];
        }
      });
      result.forEachFail((error) => {
        this.notifyFail(error.title);
      });
      this.isAwaitRequest = false;
      return result;
    },
    /**
     * @description Получить статусы плана лечения.
     * @returns {void}
     */
    fetchPlanStatuses() {
      this.$planGateway.getAllStatuses().then((items) => {
        this.planStatuses = items;
      });
    },
    /**
     * @description Получить статусы плана лечения.
     * @returns {void}
     */
    fetchResponsibleEmployeeList() {
      const onResponse = ({ data }) => {
        this.employeeList = data;
      };
      this.$planGateway.getResponsibleEmployeeList().then((result) => result.forEach(onResponse));
    },
    /**
     * @description Получить данные для заполнения плана лечения.
     * @returns {void}
     */
    fetchTreatmentPlanFillers() {
      const onResponse = ({
        templates,
        priceLists,
        periodTypes,
        defaultDate,
        doctorList,
        initialDoctorId,
      }) => {
        this.serviceGroupedByPriceList = priceLists.filter((item) => item.isHasServices());
        this.templates = templates.filter((template) => !template.getHasTrashed());
        this.isAwaitTemplates = false;
        this.periodTypes = periodTypes;
        this.doctorList = doctorList;
        if (this.isCreate === true) {
          this.periodDates.push(defaultDate.from);
          this.periodDates.push(defaultDate.to);
          this.plan.effectiveUntil = defaultDate.to;
          this.doctor = initialDoctorId;
        }
      };
      const planId = Object.is(this.planId, NaN) ? null : this.planId;
      this
        .$planGateway
        .viewTreatmentPlanFillers(planId)
        .then((result) => result.forEach(onResponse));
    },
    /**
     * @description Обработать применение шаблона к текущему плану.
     * @param {number} templateId Идентификатор шаблона.
     * @returns {void}
     */
    onApplyTemplate(templateId) {
      if (this.plan.templateId === templateId) {
        return;
      }
      this.templates
        .flatMap((item) => (item.getId() === templateId ? [item] : []))
        .forEach((item) => {
          if (this.hasStages && item.getStages().length === 0) {
            const stage = new PlanTemplateStage(null, 'Этап 1', item.getServices());
            const template = item.setStages([stage]);
            this.plan = this.plan.applyTemplate(template);
            this.templateWasApplied = true;
            return;
          }
          const needGroupServiceToStage = (
            item.getStages().length > 0
            && !this.hasStages
            && this.plan.serviceList.length > 0
          );
          if (needGroupServiceToStage) {
            this.plan.stages.push(new PatientPlanStage(null, this.plan.serviceList, 'Этап 1'));
            this.plan.serviceList = [];
          }
          this.plan = this.plan.applyTemplate(item);
          this.templateWasApplied = true;
        });
    },
    /**
     * @description Обработать создание нового плана.
     * @returns {Promise<Validation>}
     */
    async onCreatePlan() {
      const result = await this.sendCreatePlanRequest(this.patientId, this.plan);
      result.forEach(({ message, planId }) => {
        this.inputErrors = {};
        this.notifySuccess(message);
        const to = this.getLocation(this.patientId, planId);
        this.$router.replace(to);
      });
      return result;
    },
    /**
     * @description Открыть план.
     * @param {number} planId Идентификатор плана.
     * @returns {void}
     */
    openPlan(planId) {
      if (this.plan.id === planId) {
        return;
      }
      const navigate = () => {
        const to = this.getLocation(this.patientId, planId);
        this.$router.replace(to);
      };
      this.beforePlanLeave(navigate);
    },
    /**
     * @description Обработать удаление плана лечения.
     * @param {number} id Идентификатор плана.
     * @returns {void}
     */
    async onDeletePlan(id) {
      const dialog = await this.showRemoveDialog('Удалить план лечения безвозвратно?');
      if (dialog.result !== DialogResult.DELETE) {
        return;
      }
      const either = await this.$planGateway.delete(id);
      either.forEach(({ message }) => {
        this.notifySuccess(message);
        this.planList = this.planList.filter((plan) => plan.id !== id);
        if (this.planList.length > 0) {
          this.fetchPlan(this.planList[0].id);
        } else {
          this.openPlanList();
        }
      });
      either.forEachFail(({ title }) => {
        this.notifyFail(title);
      });
    },
    /**
     * @description Обработать изменение услуги.
     * @param {number} index Порядковый номер услуги в таблице.
     * @param {any}    value Данные.
     * @returns {void}
     */
    onChangeService(index, value) {
      this.$set(this.plan.serviceList, index, value);
    },
    /**
     * @description Обработать изменения этапа.
     * @param index
     * @param value
     */
    onChangeStage(index, value) {
      this.$set(this.plan.stages, index, value);
    },
    /**
     * @description Обработать удаление услуги из плана.
     * @param {number} index Порядковый номер услуги в таблице.
     * @returns {void}
     */
    async onDeleteService(index) {
      if (this.isAwaitRequest) {
        return;
      }
      const dialog = await this.showRemoveDialog('Вы действительно хотите удалить услугу?');
      if (dialog.result !== DialogResult.DELETE) {
        return;
      }
      const service = this.plan.serviceList[index];
      if (service.id) {
        this.isAwaitRequest = true;
        const either = await this.$planGateway.deleteService(this.plan.id, service.id);
        either.forEach((message) => {
          this.notifySuccess(message);
          this.$delete(this.plan.serviceList, index);
          this.plan.refresh();
          this.reloadPlanList();
        });
        this.isAwaitRequest = false;
      } else {
        this.$delete(this.plan.serviceList, index);
        this.plan.refresh();
      }
    },
    /**
     * @description Добавление этапу услуги
     * @param index
     */
    addStageService(index) {
      this.selectedStage = index;
    },
    /**
     * @description Удаление этапа
     * @param index
     * @return {Promise<void>}
     */
    async onDeleteStage(index) {
      if (this.isAwaitRequest) {
        return;
      }
      const dialog = await this.showRemoveDialog('Вы действительно хотите удалить этап?');
      if (dialog.result !== DialogResult.DELETE) {
        return;
      }
      this.$delete(this.plan.stages, index);
    },
    /**
     * @description Обработать редактирование плана.
     * @returns {void}
     */
    async onEditPlan() {
      this.isAwaitRequest = true;
      const result = await this.sendEditPlanRequest(this.plan);
      result.forEach(async ({ message }) => {
        this.notifySuccess(message);
        this.fetchPlan(this.plan.id);
        this.fetchTreatmentPlanFillers();
        this.reloadPlanList();
      });
      this.isAwaitRequest = false;
    },
    /**
     * @description Обработать сохранение плана.
     * @returns {void}
     */
    onSavePlan() {
      this.plan.serviceList = this.plan.serviceList.filter((item) => item.serviceId !== null);
      if (this.isCreate === true) {
        this.onCreatePlan();
      } else {
        this.onEditPlan();
      }
    },
    /**
     * @description Обработать печать плана.
     * @returns {void}
     */
    onPlanPrint() {
      if (this.plan.isChanged()) {
        this.notifyFail('Сначала сохраните план лечения');
        return;
      }
      const onSuccess = (response) => {
        const blob = new Blob([response], { type: 'text/html' });
        const container = this.$refs.printView;
        container.setAttribute('src', URL.createObjectURL(blob));
        container.onload = () => {
          container.contentWindow.print();
        };
      };
      const onFail = (error) => {
        this.notifyFail(error.getTitle());
      };
      const planId = this.selectedId;
      if (!this.hasServices) {
        this.notifyFail('Сначала добавьте услуги и сохраните план лечения');
        return;
      }
      if (!planId) {
        this.notifyFail('Сначала сохраните план лечения');
        return;
      }
      this.$planGateway.printById(planId).then(
        (result) => result.fold(onFail, onSuccess),
      );
    },
    /**
     * @description Обработать сохранение плана.
     * @returns {void}
     */
    onPlanDownload() {
      const onSuccess = (blob) => {
        this.saveFile(
          blob,
          `${this.plan.name} ${this.plan.patientName.split('.').join('')}.docx`,
        );
      };
      const onFail = (error) => {
        this.notifyFail(error.getTitle());
      };
      const planId = this.selectedId;
      if (!this.hasServices) {
        this.notifyFail('Сначала добавьте услуги и сохраните план лечения');
        return;
      }
      if (!planId) {
        this.notifyFail('Сначала сохраните план лечения');
        return;
      }
      this.$planGateway.downloadById(planId).then(
        (result) => result.fold(onFail, onSuccess),
      );
    },
    /**
     * @description Привести скидку к копейкам.
     * @param {PlanService[]} services
     * @returns {PlanService[]}
     */
    convertDiscountToKopeck(services) {
      const { discountType } = this.plan;
      const convert = (candidate) => candidate.discount.convertToKop(candidate.amount.toKop());
      return services.map(
        (candidate) => (candidate.discount.getType() === discountType
          ? candidate
          : candidate.setDiscount(convert(candidate))
        ),
      );
    },
    /**
     * @description Привести скидку к процентам.
     * @param {PlanService[]} services
     * @returns {PlanService[]}
     */
    convertDiscountToPercent(services) {
      const { discountType } = this.plan;
      const convert = (candidate) => candidate.discount.convertToPercent(candidate.amount.toKop());
      return services.map(
        (candidate) => (candidate.discount.getType() === discountType
          ? candidate
          : candidate.setDiscount(convert(candidate))),
      );
    },
    /**
     * @description Обработать ввод типа скидки.
     * @param {boolean} value
     * @returns {void}
     */
    onInputDiscountType(value) {
      this.plan.discountType = value;
      const converter = value === DISCOUNT_IN_KOPECK
        ? this.convertDiscountToKopeck
        : this.convertDiscountToPercent;
      if (this.hasStages) {
        this.plan.stages = this.plan.stages.map(
          (stage) => stage.setServiceList(converter(stage.serviceList)),
        );
      } else {
        this.plan.serviceList = converter(this.plan.serviceList);
      }
    },
    /**
     * @description Перезагрузить список планов лечения пациента.
     * @returns {void}
     */
    async reloadPlanList() {
      this.isAwaitRequest = true;
      const { patientId } = this;
      const either = await this.$planGateway.viewList(patientId);
      either.forEach(({ list }) => {
        this.planList = list;
      });
      either.forEachFail((error) => {
        const failurePairs = error.causes.map((cause) => [cause.source, cause.details]);
        if (failurePairs.length === 0) {
          this.notifyFail(error.title);
        }
        this.inputErrors = Object.fromEntries(failurePairs);
      });
      this.isAwaitRequest = false;
    },
    /**
     * @description Сохранить и продолжить.
     * @returns {void}
     */
    async saveAndLeave() {
      const result = await this.saveBeforeLeave();
      result.forEach(({ message }) => {
        this.notifySuccess(message);
        this.reloadPlanList();
        this.actionAfterClosingDialogLeaveConfirm();
      });
      this.isShownDialogLeaveConfirm = false;
    },
    /**
     * @description Сохранить перед выходом.
     * @returns {Promise<Validation>}
     */
    async saveBeforeLeave() {
      this.plan.serviceList = this.plan.serviceList.filter((item) => item.serviceId !== null);
      if (this.isCreate) {
        return this.sendCreatePlanRequest(this.patientId, this.plan);
      }
      return this.sendEditPlanRequest(this.plan);
    },
    /**
     * @description Отправить запрос на создание услуги.
     * @param {number} patientId Идентификатор пациента.
     * @param {Plan} plan План.
     * @returns {Promise<Validation>}
     */
    async sendCreatePlanRequest(patientId, plan) {
      const request = new CreatePlanRequest(patientId, plan);
      const result = await this.$planGateway.create(request);
      result.forEachFail((error) => {
        const failurePairs = error.causes.map((cause) => [cause.source, cause.details]);
        if (failurePairs.length === 0) {
          this.notifyFail(error.title);
        }
        this.inputErrors = Object.fromEntries(failurePairs);
      });
      return result;
    },
    /**
     * @description Отправить запрос на редактирование плана.
     * @param {Plan} plan План.
     * @returns {Promise<Validation>}
     */
    async sendEditPlanRequest(plan) {
      const request = new EditPlanRequest(plan);
      const result = await this.$planGateway.edit(request);
      result.forEach(() => {
        this.inputErrors = {};
      });
      result.forEachFail((error) => {
        const failurePairs = error.causes.map((cause) => [cause.source, cause.details]);
        this.notifyFail(error.title);
        this.inputErrors = Object.fromEntries(failurePairs);
      });
      return result;
    },
    /**
     * @description Отобразить компонент для ввода названия плана.
     * @returns {void}
     */
    showInputPlanName() {
      this.isEditPlanName = true;
      this.$nextTick(() => this.$refs.planName.focus());
    },
    /**
     * @description Открыть список планов лечения.
     * @returns {void}
     */
    openPlanList() {
      const to = this.getListLocation(this.patientId);
      this.$router.push(to);
    },
    onMoveRow(element, before) {
      const firstIndex = this.plan.serviceList.indexOf(element);
      const secondIndex = this.plan.serviceList.indexOf(before);
      if (firstIndex < secondIndex && secondIndex - firstIndex < 2) {
        return;
      }
      this.insertBefore(this.plan.serviceList, firstIndex, before);
      this.calcOrder();
    },
    onMoveRowLast(element) {
      const index = this.plan.serviceList.indexOf(element);
      this.plan.serviceList.splice(index, 1);
      this.plan.serviceList.push(element);
      this.calcOrder();
    },
    insertBefore(list, firstIndex, before) {
      const element = list[firstIndex];
      list.splice(firstIndex, 1);
      const indexBeforeService = list.indexOf(before);
      list.splice(indexBeforeService, 0, element);
    },
    onMoveRowBetweenStages(firstStage, secondStage, element, before) {
      if (firstStage === secondStage) {
        const firstIndex = firstStage.serviceList.indexOf(element);
        const secondIndex = firstStage.serviceList.indexOf(before);
        if (firstIndex < secondIndex && secondIndex - firstIndex < 2) {
          return;
        }
        this.insertBefore(firstStage.serviceList, firstIndex, before);
        this.calcOrder();
      } else {
        const firstIndex = firstStage.serviceList.indexOf(element);
        firstStage.serviceList.splice(firstIndex, 1);
        const indexBeforeService = secondStage.serviceList.indexOf(before);
        secondStage.serviceList.splice(indexBeforeService, 0, element);
        this.calcOrder();
      }
    },
    onMoveRowBetweenStagesLast(firstStage, secondStage, element) {
      const index = firstStage.serviceList.indexOf(element);
      firstStage.serviceList.splice(index, 1);
      if (firstStage === secondStage) {
        firstStage.serviceList.push(element);
      } else {
        secondStage.serviceList.push(element);
      }
      this.calcOrder();
    },
    calcOrder() {
      const updateOrder = (list) => list.map((service, index) => service.setOrder(index));
      if (this.hasStages) {
        this.plan.stages = this.plan.stages.map(
          (stage) => stage.setServiceList(updateOrder(stage.serviceList)),
        );
      } else {
        this.plan.serviceList = updateOrder(this.plan.serviceList);
      }
    },
  },
  mixins: [
    addingServicesFromPriceMixin,
    builtInDialogMixin,
    dateMixin,
    notifierMixin,
    patientPlanMixin,
    preventLeaveWithoutConfirmMixin,
    mobileMixin,
    mobilePopupMixin,
    saveFileMixin,
  ],
  name: 'ClinicPanelPatientPlan',
};
</script>

<style lang="scss" scoped>
@use "@/scss/buttons";

.treatment-plan-templates {
  &__description {
    color: var(--unfocus-color);
    font-size: 1rem;
    margin-bottom: 10px;
  }
}

.patient-plans {
  display: flex;
  flex-direction: column;
  padding-top: 15px;
  &__empty {
    align-self: baseline;
    cursor: pointer;
    display: inline;
    font-size: 18px;
    b {
      color: var(--action-color);
    }
  }
  &__slider {
    margin-top: 15px;
  }
  &__slide {
    text-align: left;
    background: #eaeff3;
    border-radius: 4px;
    padding: 14px 19px;
    font-weight: 500;
    font-size: 17px;
    line-height: 20px;
    color: #192a3e;
    margin: 0 3px;
    cursor: pointer;
    border: 2px solid transparent;
    &.selected {
      border: 2px solid #0489e0;
      color: #0489e0;
    }
    &:hover {
      border: 2px solid #0489e0;
    }
    &__row {
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      justify-content: space-between;
      gap: 10px;
      margin: 0 0 5px 0;
    }
    &__name {
      color: #90a0b7;
      font-weight: 400;
      font-size: 14px;
      line-height: 17px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    &__icon-delete {
      align-self: center;
      justify-self: center;
      background-image: url("@/assets/img/exit-grey.svg");
      background-size: contain;
      background-repeat: no-repeat;
      width: 14px;
      min-width: 14px;
      height: 14px;
      min-height: 14px;
      cursor: pointer;
      &:hover {
        background-image: url("@/assets/img/exit-blue.svg");
      }
    }
    &__price {
      color: #90a0b7;
      font-weight: 500;
      font-size: 17px;
      line-height: 20px;
      margin: 15px 0 0 0;
      span {
        color: #192a3e;
        font-weight: 500;
      }
    }
  }
  &__plan {
    background-color: #f2f5f8 !important;
    padding: 32px 26px 26px;
    width: 100%;
    display: flex;
    flex-direction: column;
    row-gap: 14px;
    &__search-input {
      width: 100%;
    }
    &__status {
      width: min(100%, 242px);
      cursor: pointer;
    }
    &__employee {
      display: flex;
      flex-direction: column;
      row-gap: 3px;
      width: 100%;
      max-width: 450px;
    }
    &__employee-title {
      display: block;
      font-size: 12px;
      line-height: 16px;
      font-weight: 400;
      color: var(--unfocus-color);
    }
    &__employee-field {
      background-color: #ffffff;
      ::v-deep .v-input {
        &:not(.v-input--is-focused):not(.v-input--has-state) fieldset {
          border: 1px solid var(--border-color);
        }
        &.primary--text {
          color: var(--action-color) !important;
        }
      }
    }
    &__link {
      display: flex;
      margin: 20px 0 0 0;
      &:hover {
        text-decoration: none;
      }
    }
    &__row {
      display: flex;
      align-items: center;
      margin: 0 0 24px 0;
    }
    &__search {
      max-width: 712px;
    }
    &__group {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: baseline;
      &-name {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 14px;
        & > p {
          max-width: 500px;
          font-size: 24px;
          font-weight: 600;
          line-height: 29px;
          margin: 0;
        }
      }
      &-inputs {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 20px;
      }
      &__checkbox {
        margin-top: 29px !important;
      }
    }
    &__name {
      width: fit-content;
      font-size: 24px;
      font-weight: 600;
      line-height: 29px;
      border: 1px solid #c2cfe0;
      &:focus {
        color: #192a3e;
        background-color: #fff;
        border: 1px solid #0489e0 !important;
        outline: 0;
      }
    }
    &__icon-edit {
      background-image: url("@/assets/img/pen-grey.svg");
      background-size: contain;
      background-repeat: no-repeat;
      width: 15px;
      min-width: 15px;
      height: 15px;
      min-height: 15px;
      padding: 0;
      cursor: pointer;
      &:hover {
        background-image: url("@/assets/img/pen-blue.svg");
      }
    }
    &__datetime {
      color: var(--action-color);
      font-size: 18px;
      font-weight: 700;
      line-height: 22px;
      margin-left: 28px;
      border-bottom: 1px solid #abd5f1;
      cursor: pointer;
      width: fit-content;
      &:hover {
        border-bottom: 1px solid transparent;
      }
    }
    &__datetime-field {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: space-between;
      column-gap: 10px;
      width: min(100%, 160px);
      height: 40px;
      padding-left: 10px;
      border: 1px solid #C2CFE0;
      border-radius: 4px;
      background: #FFFFFF;
      font-weight: 400;
      font-size: 16px;
      line-height: 19px;
      &:after {
        content: '';
        width: 38px;
        height: 38px;
        background-color: #EAEFF3;
        background-image: url("@/assets/img/calendar-grey.svg");
        background-position: center;
        border-radius: 0 4px 4px 0;
        overflow: hidden;
      }
    }
    &__date-range {
      ::v-deep {
        .preset__label {
          width: 68px;
          height: 32px;
        }
        .date-range-presets__button {
          height: 32px;
        }
      }
    }
    .validity-period {
      align-items: center;
      gap: 10px 22px;
      &__text {
        font-weight: 600;
      }
      &__button {
        margin-left: 0;
      }
    }
    &__buttons {
      justify-self: end;
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-gap: 20px;
      max-width: 500px;
      margin: 20px 0 0 0
    }
    &__buttons-second {
      justify-self: end;
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      grid-gap: 20px;
      max-width: 760px;
      margin: 20px 0 0 0
    }
    &__button {
      &-print {
        @include buttons.btn-transparent(100%, 48px, 16px);
        background-color: transparent;
        padding: 0;
        margin: 0;
        &:before {
          content: "";
          background-image: url("@/assets/img/print.svg");
          background-repeat: no-repeat;
          background-size: contain;
          width: 24px;
          height: 24px;
          margin: 0 8px 0 0;
        }
        &:disabled {
          color: var(--unfocus-color);
        }
      }
      &-download {
        @include buttons.btn-transparent(100%, 48px, 16px);
        background-color: transparent;
        padding: 0;
        margin: 0;
        &:before {
          content: "";
          background-image: url("@/assets/img/download-blue.svg");
          background-repeat: no-repeat;
          background-size: contain;
          width: 24px;
          height: 24px;
          margin: 0 8px 0 0;
        }
        &:disabled {
          color: var(--unfocus-color);
        }
      }
      &-save {
        @include buttons.btn-blue(100%, 48px, 16px);
        justify-self: end;
        margin: 0;
        padding: 0;
        &:disabled {
          background-color: var(--unfocus-color);
        }
      }
      &-add {
        @include buttons.btn-transparent(100%, 48px, 16px);
        &::before {
          content: "+";
          margin-right: 4px;
        }
      }
    }
  }
  &__print {
    display: none;
  }
  &__button-save {
    @include buttons.btn-blue(100%, 48px, 16px);
    max-width: 266px;
    margin-top: 39px;
  }
  &__button-add {
    margin-top: 20px;
    @include buttons.btn-transparent(100%, 40px, 16px);
    max-width: 160px;
    &::before {
      content: "+";
      margin-right: 4px;
    }
  }
  &__button-create {
    @include buttons.btn-blue(100%, 48px, 16px);
    @include buttons.btn-blue-add(16px);
    max-width: 299px;
  }
}
.text__violation {
  color: var(--warning-color);
  font-size: 12px;
  line-height: 14px;
  font-weight: 400;
  padding: 0.125rem;
}

@media screen and (max-width: 1280px) {
  .patient-plans {
    &__plan {
      &__row {
        grid-template-columns: 1fr;
        grid-gap: 20px;
      }
      &__buttons {
        grid-row-start: 1;
        justify-self: start;
      }
    }
  }
}

@media screen and (max-width: 767px) {
  .validity-period {
    display: grid;
    align-items: center;
    &__text {
      grid-column: span 3;
    }
  }
}

@media screen and (max-width: 600px) {
  .patient-plans {
    &__plan {
      &__group {
        flex-direction: column;
        align-items: flex-start;
        grid-gap: 10px;
        &-name {
          flex-wrap: wrap;
        }
        .validity-period {
          &__text {
            grid-column: span 2;
          }
        }
      }
      &__datetime {
        margin-left: 0;
      }
      &__buttons {
        grid-template-columns: 1fr;
        width: 100%;
        gap: 10px;
      }
    }
  }
}

@media screen and (max-width: 500px) {
  .patient-plans__plan {
    &__button-print {
      display: none;
    }
    &__group-inputs {
      display: grid;
    }
    &__status {
      width: 100%;
    }
    .validity-period {
      grid-template-columns: 1fr;
      row-gap: 15px;
      &__text {
        grid-column: auto;
      }
    }
  }
}
</style>
